import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { IHelpFile } from '../../../api/fetchers/help/fetcher';
import { fetchHelpAction } from '../../apiActions/fetchHelpAction';

export const helpSlice = createSlice({
  name: 'help',
  initialState: (): {
    helpFile: IHelpFile | null;
    isSorted: boolean;
    helpModalHeight: number | null;
    fetchError: boolean;
  } => {
    return {
      helpFile: null,
      isSorted: false,
      helpModalHeight: null,
      fetchError: false,
    };
  },
  reducers: {
    updateHelpFile: (state, action: PayloadAction<IHelpFile>) => {
      state.helpFile = Object.assign({}, state.helpFile, action.payload);
    },
    sortHelpChapters: (state, action: PayloadAction<string[]>) => {
      if (state.helpFile) {
        const sortedHelpFile: IHelpFile = {};

        action.payload.forEach((key) => {
          if (state.helpFile && state.helpFile[key]) {
            sortedHelpFile[key] = state.helpFile[key];
          }
        });

        state.helpFile = sortedHelpFile;
      }
    },
    setIsSorted: (state, action: PayloadAction<boolean>) => {
      state.isSorted = action.payload;
    },
    setHelpNavHeight: (state, action: PayloadAction<number>) => {
      state.helpModalHeight = Math.ceil(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHelpAction.fulfilled, (state, action) => {
      state.helpFile = { ...state.helpFile, ...action.payload };
    });
    builder.addCase(fetchHelpAction.rejected, (state) => {
      state.fetchError = true;
    });
  },
});

export const helpActions = helpSlice.actions;
